// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../k8-opt-exec-ST-d57f47055a04/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../k8-opt-exec-ST-d57f47055a04/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._q-0 {\n  z-index: 2147483006 !important; /* 1 higher than RedoDropdown */\n}\n\n._q-1 {\n  font-size: var(--size-body-xs);\n  line-height: 18px;\n  color: var(--redo-colors-text-text-quarterary-500);\n}\n\n._q-2 {\n  text-align: left;\n}\n", ""]);
// Exports
export var popper = "_q-0";
export var subtitle = "_q-1";
export var leftAlign = "_q-2";
export default ___CSS_LOADER_EXPORT___;
